import type { PropsWithChildren } from 'react'
import { useCanAccess } from '@publisher/modules/permissions/hooks'
import { LoadingScreen } from './LoadingScreen'

interface ProtectedRouteProps extends PropsWithChildren {
  allowedRoles?: string[]
  fallbackRedirect?: string
  resource?: string
  action?: string
}

export const ProtectedRouteHandler = ({
  children,
  allowedRoles,
  fallbackRedirect,
  resource,
  action,
}: ProtectedRouteProps) => {
  const { isLoading, canAccess } = useCanAccess({
    allowedRoles,
    fallbackRedirect,
    resource,
    action,
  })

  if (isLoading) return <LoadingScreen />
  if (!canAccess) return null

  return children as JSX.Element
}
